import React from "react";
import { Card, CardTitle, CardBody, Col, Row } from "reactstrap";

const AuditInfo = ({
  createdOn,
  createdBy,
  generatedOn,
  generatedBy,
  finished,
}) => {
  return (
    <Card className="mb-4">
      <CardTitle tag="h5">Audit</CardTitle>
      <CardBody>
        <Row>
          <Col>
            <p className="mb-2">
              <i style={{ color: "#9d9c9c" }}>
                <span
                  style={{
                    display: "flex",
                    width: "9em",
                    whiteSpace: "nowrap",
                  }}
                ></span>
                Créée le :
              </i>{" "}
              {createdOn}
            </p>
            <p className="mb-2">
              <i style={{ color: "#9d9c9c" }}>
                <span
                  style={{
                    display: "flex",
                    width: "9em",
                    whiteSpace: "nowrap",
                  }}
                ></span>
                Générée le :{" "}
              </i>{" "}
              {generatedOn}
            </p>
          </Col>
          <Col>
            <p className="mb-2">
              <i style={{ color: "#9d9c9c" }}>
                <span
                  style={{
                    display: "flex",
                    width: "9em",
                    whiteSpace: "nowrap",
                  }}
                ></span>
                Créée par :
              </i>{" "}
              {createdBy}
            </p>
            <p className="mb-2">
              <i style={{ color: "#9d9c9c" }}>
                <span
                  style={{
                    display: "flex",
                    width: "9em",
                    whiteSpace: "nowrap",
                  }}
                ></span>
                Générée par :{" "}
              </i>
              {generatedBy}
            </p>
          </Col>
          <Col>
            <p className="mb-2">
              <i style={{ color: "#9d9c9c" }}>
                <span
                  style={{
                    display: "flex",
                    width: "9em",
                    whiteSpace: "nowrap",
                  }}
                ></span>
                Fin :{" "}
              </i>
              {finished}
            </p>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default AuditInfo;
